import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddTraining(props) {
  return(
    <PostAdd 
      targetVid={"training_categories"}
      addPostEndpoint={apiEndpoints.training}
      editRoute={"/training/edit"}
      entityType={"training"}
      pageTitle={"Create a training post"}
      returnRoute={"/training-creator"}
    />
  )
}
